// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2wggR","vLegacy":"SelectSecondary_vLegacy__2pd1Q","error":"SelectSecondary_error___TstU","disabled":"SelectSecondary_disabled__ZGO-W"};